.grid {
  display: grid;
  grid-template-columns: 1.05fr 1fr;
  gap: 1.25rem;
}

.card {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-lg, 16px);
  padding: 1.3rem;
  display: flex;
  flex-direction: column;
  gap: 1.05rem;
  box-shadow: 0 4px 18px rgba(13, 28, 46, 0.05);
}

.title {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 1.04rem;
  font-weight: 800;
  color: #00236f;
  letter-spacing: -0.015em;
}

.subtitle {
  font-size: 0.8rem;
  color: #444651;
}

.modeSwitchRow {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.65rem;
}

.modeOption {
  padding: 0.8rem 0.9rem;
  border-radius: var(--radius-md, 12px);
  border: 1px solid #dce9ff;
  background: #f8f9ff;
  text-align: left;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.modeOptionActive {
  border-color: #00236f;
  background: linear-gradient(145deg, #eff4ff 0%, #e6eeff 100%);
}

.modeTag {
  font-family: var(--font-mono, monospace);
  font-size: 0.68rem;
  font-weight: 700;
  color: #006a61;
}

.modeName {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 0.85rem;
  font-weight: 800;
  color: #0d1c2e;
}

.modeDesc {
  font-size: 0.74rem;
  color: #444651;
}

.allowlistBox {
  background: #f8f9ff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-md, 12px);
  padding: 0.95rem;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.allowlistRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.65rem 0.8rem;
  border-radius: var(--radius-sm, 8px);
  background: #ffffff;
  border: 1px solid #dce9ff;
}

.emailText {
  font-family: var(--font-mono, monospace);
  font-size: 0.8rem;
  font-weight: 700;
  color: #0d1c2e;
}

.roleSub {
  font-size: 0.72rem;
  color: #444651;
}

.verifiedPill {
  font-family: var(--font-mono, monospace);
  font-size: 0.68rem;
  font-weight: 700;
  padding: 0.16rem 0.5rem;
  border-radius: 999px;
  background: #e6f7f5;
  border: 1px solid #86f2e4;
  color: #006a61;
}

.testerBox {
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-md, 12px);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.quickEmailsRow {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.chipBtn {
  font-family: var(--font-mono, monospace);
  font-size: 0.72rem;
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
  border: 1px solid #c5c5d3;
  background: #ffffff;
  color: #444651;
  cursor: pointer;
}

.chipBtn:hover {
  border-color: #00236f;
  color: #00236f;
  background: #f8f9ff;
}

.inputRow {
  display: flex;
  gap: 0.55rem;
}

.input {
  flex: 1;
  background: #ffffff;
  border: 1px solid #c5c5d3;
  border-radius: var(--radius-sm, 8px);
  padding: 0.58rem 0.75rem;
  font-family: var(--font-mono, monospace);
  font-size: 0.82rem;
  color: #0d1c2e;
  outline: none;
}

.input:focus {
  border-color: #00236f;
  box-shadow: 0 0 0 3px rgba(0, 35, 111, 0.1);
}

.testBtn {
  padding: 0.58rem 0.95rem;
  border-radius: var(--radius-sm, 8px);
  border: none;
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  color: #ffffff;
  font-weight: 700;
  font-size: 0.8rem;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 35, 111, 0.2);
}

.responseConsole {
  background: #f8f9ff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-sm, 8px);
  padding: 0.85rem;
  font-family: var(--font-mono, monospace);
  font-size: 0.74rem;
  line-height: 1.5;
  overflow-x: auto;
  white-space: pre-wrap;
  color: #0d1c2e;
}

.consoleBlocked {
  background: #fff5f5;
  border-color: #ffb4ab;
  color: #ba1a1a;
}

.consoleAllowed {
  background: #e6f7f5;
  border-color: #86f2e4;
  color: #005049;
}

.scopesGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
}

.scopeLabel {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 0.65rem;
  border-radius: var(--radius-sm, 8px);
  background: #f8f9ff;
  border: 1px solid #dce9ff;
  font-family: var(--font-mono, monospace);
  font-size: 0.74rem;
  color: #0d1c2e;
  cursor: pointer;
}

.keyCard {
  background: #f8f9ff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-md, 12px);
  padding: 0.8rem 0.95rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.tokenString {
  font-family: var(--font-mono, monospace);
  font-size: 0.76rem;
  color: #00236f;
  font-weight: 700;
  word-break: break-all;
}

@media (max-width: 980px) {
  .grid,
  .modeSwitchRow {
    grid-template-columns: 1fr;
  }
}
